/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Tags_Add_MoreInputs */

const cs_form_tags_add_more = /** @type {(inputs: Form_Tags_Add_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Další štítek…`)
};

const en_form_tags_add_more = /** @type {(inputs: Form_Tags_Add_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add another tag…`)
};

/**
* | output |
* | --- |
* | "Add another tag…" |
*
* @param {Form_Tags_Add_MoreInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_tags_add_more = /** @type {((inputs?: Form_Tags_Add_MoreInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Tags_Add_MoreInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_tags_add_more(inputs)
	return cs_form_tags_add_more(inputs)
});